import { render, staticRenderFns } from "./VEmployerServicesCandidates.vue?vue&type=template&id=71093cfb&scoped=true&lang=pug"
import script from "./VEmployerServicesCandidates.vue?vue&type=script&lang=ts"
export * from "./VEmployerServicesCandidates.vue?vue&type=script&lang=ts"
import style0 from "./VEmployerServicesCandidates.vue?vue&type=style&index=0&id=71093cfb&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71093cfb",
  null
  
)

/* custom blocks */
import block0 from "./EmployerServicesCandidates.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fpages%2FLayout%2Fviews%2FEmployer%2Fviews%2FServicesCandidatesNew%2FVEmployerServicesCandidates.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports